import { useEffect } from 'react';
import DefaultFallback from './DefaultFallback';
import { useSession } from '../Context';
import { useManagement } from '../hooks/management';

const Closed = ({ fallback, setState }) => {
  const { cable } = useSession();
  const management = useManagement();
  useEffect(() => {
    cable.disconnect();
    management.close();
    setState('AUTHENTICATING');
  }, [cable, management, setState]);
  return fallback || <DefaultFallback />;
};
export default Closed;
